import { useEffect, useRef } from 'react';

import { PageSpinner } from '@/components/ui/Spinner';
import { useAuth } from '@/features/auth/useAuth';

/** Runs the one-time auth bootstrap (refresh cookie → access token → /me) and
 *  blocks the app behind a spinner until the session state is known. */
export function RootGate({ children }: { children: React.ReactNode }) {
  const { status, bootstrap } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    void bootstrap();
  }, [bootstrap]);

  if (status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center">
        <PageSpinner />
      </div>
    );
  }
  return <>{children}</>;
}
